/**
 * Register Modal
 * Register a Candidate for Event
 */
import React from "react"
import PropTypes from "prop-types"
import {
  UniversityRowItem,
  UniversityRow,
  ContentWrapper,
  EventPleaseSpecifyInput,
} from "./styles"
import { CloseButton, FooterWrapper, FormRow } from "styles/Modal"
import Modal from "components/Modal"
import InputField from "components/InputField"
import Icon from "components/Icon"
import TextButton from "components/TextButton"
import Button from "components/Button"
import SelectField from "components/SelectField"
import CheckboxField from "components/CheckboxField"
import UniversityName from "components/UniversityName"
import {
  SectionHasErrors,
  isEmail,
  isBooleanTrue,
  isEmpty,
  getValuableResourceOptions,
  isNull,
} from "utils/utils"
import { isOZAPI } from "utils/clientUtils"
import {
  UNI_YEARS_LIST,
  DEGREE_TYPE,
  UNDERGRADUATE,
  PRONOUNS_LIST,
} from "utils/constants"
import { shouldShowEventItem } from "utils/events/eventUtils"
import { getFormConfigurationFromOrganization } from "utils/configUtils"

import PhoneNumber from "components/PhoneNumber"
import { isValidPhoneNumber } from "react-phone-number-input"

import SwitchField from "components/SwitchField"

export class RegisterModal extends React.Component {
  state = {
    loading: false,
    haventStartedUniversity: false,
    readTermsandConditions: false,
    firstName: "",
    lastName: "",
    university: {},
    email: "",
    mobileNumber: null,
    dietaryRequirementsDetail: null,
    dietaryRequirements: null,
    hasAccessibility: null,
    accessibility: null,
    pronoun: null,
    customPronoun: null,
    howDidYouHear: null,
  }

  handleOptionChange = (id, value, callback) => {
    const { university } = this.state
    const idName = id.substring(0, id.indexOf("-"))
    university[idName] = value
    this.setState(
      {
        university,
      },
      callback
    )
  }

  handleChange = ev => {
    const { university } = this.state
    const idName = ev.target.id.substring(0, ev.target.id.indexOf("-"))
    university[idName] = ev.target.value
    this.setState({
      university,
    })
  }

  onChange = (id, value) => {
    this.setState({ [id]: value })
  }

  clearStateFields = fields => {
    const { university } = this.state
    fields.forEach(field => {
      university[field] = null
    })
    this.setState({
      university,
    })
  }

  render() {
    const {
      firstName,
      lastName,
      email,
      university,
      hasErrors,
      haventStartedUniversity,
      readTermsandConditions,
      universityGraduationYear,
      degreeTypeId,
      mobileNumber,
      dietaryRequirementsDetail,
      dietaryRequirements,
      accessibilityRequirements,
      accessibilityRequirementsDetail,
      photoConsent,
      pronoun,
      customPronoun,
      howDidYouHear,
    } = this.state
    const {
      isModalOpen,
      onClose,
      align = "left",
      loading,
      onConfirm,
      organization,
      configuration,
    } = this.props
    const org_heard = getValuableResourceOptions(organization)
    const formConfig = getFormConfigurationFromOrganization(organization)
    const replyToEmail = formConfig?.text?.defaultReplyTo
    const showHaventStartedUniversity =
      shouldShowEventItem(configuration, "university") ||
      shouldShowEventItem(configuration, "degreeType") ||
      shouldShowEventItem(configuration, "graduationYear")
    const showUniversity =
      !haventStartedUniversity &&
      shouldShowEventItem(configuration, "university")
    const showCountryDropdown = showUniversity
    const showUniversityNameOther =
      showUniversity && university.universityNotAttendedInUk === true
    const showUniversityName =
      showUniversity && university.universityNotAttendedInUk !== true
    const showPronouns = shouldShowEventItem(configuration, "pronouns")
    const useCustomPronouns = PRONOUNS_LIST.find(({ id }) => id === pronoun)
      ?.custom
    const showDegreeType =
      !haventStartedUniversity &&
      shouldShowEventItem(configuration, "degreeType")
    const showGraduationYear =
      !haventStartedUniversity &&
      shouldShowEventItem(configuration, "graduationYear")
    const showMobileNumber = shouldShowEventItem(configuration, "mobileNumber")
    const showDietary = shouldShowEventItem(
      configuration,
      "dietaryRequirements"
    )
    const showAccessibility = shouldShowEventItem(
      configuration,
      "accessibilityRequirements"
    )
    const showPhotoConsent = shouldShowEventItem(configuration, "photoConsent")
    const showHowDidYouHear = shouldShowEventItem(
      configuration,
      "howDidYouHear"
    )
    const showConfigurationForUniversity = {
      showUniversityNameOther,
      showUniversityName,
      showCountryDropdown,
    }

    const missingUniversityOther =
      showUniversityNameOther && !university.universityOther
    const missingUniversity = showUniversityName && !university.university
    const missingPronouns = showPronouns && isEmpty(pronoun)
    const missingCustomPronouns =
      showPronouns && useCustomPronouns && !customPronoun

    const missingEmail = isEmpty(email)
    const invalidEmail = !isEmail(email)
    const missingDegreeTypeId =
      !haventStartedUniversity && showDegreeType && !degreeTypeId
    const missingUniversityGraduationYear =
      !haventStartedUniversity &&
      showGraduationYear &&
      !universityGraduationYear
    const missingMobile = showMobileNumber && !mobileNumber
    const missingDietary = showDietary && isNull(dietaryRequirements)
    const missingDietaryData =
      isBooleanTrue(dietaryRequirements) && !dietaryRequirementsDetail
    const missingAccessibility =
      showAccessibility && isNull(accessibilityRequirements)
    const missingAccessibilityData =
      isBooleanTrue(accessibilityRequirements) &&
      !accessibilityRequirementsDetail
    const invalidMobileNumber =
      mobileNumber && !isValidPhoneNumber(mobileNumber)
    const missingHowDidYouHear = showHowDidYouHear && !howDidYouHear

    const errors = {
      missingUniversityOther,
      missingUniversity,
      missingDegreeTypeId,
      missingUniversityGraduationYear,
      missingMobile,
      invalidMobileNumber,
      missingAccessibility,
      missingAccessibilityData,
      missingDietary,
      missingDietaryData,
      missingHowDidYouHear,
      missingEmail,
      invalidEmail,
    }
    const termsComponent = (
      <React.Fragment>
        I agree to Candid’s{" "}
        <a
          href="https://www.rarerecruitment.co.uk/privacy-policy/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Privacy Policy
        </a>
      </React.Fragment>
    )

    return (
      <Modal
        open={isModalOpen}
        title={"Register for Event"}
        onExit={onClose}
        align={align}
      >
        <CloseButton onClick={onClose}>
          <Icon variant={"cross_lrg"} />
        </CloseButton>
        <ContentWrapper align={align}>
          <FormRow>
            <InputField
              id={"firstName"}
              onChange={ev => {
                this.setState({ firstName: ev.target.value })
              }}
              error={!firstName}
              errorMessage={"Required"}
              forceErrorDisplay={hasErrors}
              label={"First name"}
              value={firstName || ""}
            />
          </FormRow>

          <FormRow>
            <InputField
              id={"lastName"}
              onChange={ev => {
                this.setState({ lastName: ev.target.value })
              }}
              error={!lastName}
              errorMessage={"Required"}
              forceErrorDisplay={hasErrors}
              label={"Last name"}
              value={lastName || ""}
            />
          </FormRow>

          <FormRow>
            <InputField
              id={"email"}
              onChange={ev => {
                this.setState({ email: ev.target.value })
              }}
              error={!isEmail(email) || !email}
              errorMessage={email ? "Invalid email" : "Required"}
              forceErrorDisplay={hasErrors}
              label={"Email address"}
              value={email || ""}
            />
          </FormRow>
          {showPronouns && (
            <FormRow>
              <SelectField
                size={"mediumLarge"}
                id={`pronoun`}
                label={"Pronouns"}
                error={missingPronouns}
                errorMessage={"Required"}
                forceErrorDisplay={hasErrors}
                options={PRONOUNS_LIST}
                onChange={(id, value) => this.setState({ pronoun: value.id })}
                getOptionLabel={({ value }) => value}
                value={pronoun && PRONOUNS_LIST.find(x => x.id === pronoun)}
              />
            </FormRow>
          )}
          {useCustomPronouns && (
            <FormRow>
              <InputField
                id={"pronounsCustom"}
                onChange={ev => {
                  this.setState({ customPronoun: ev.target.value })
                }}
                label={"Custom pronoun"}
                value={customPronoun || ""}
                error={missingCustomPronouns}
                errorMessage={"Required"}
                maxLength={15}
                forceErrorDisplay={hasErrors}
              />
            </FormRow>
          )}
          {showMobileNumber && (
            <FormRow>
              <PhoneNumber
                id={"mobileNumber"}
                onChange={(id, value) => {
                  this.setState({ mobileNumber: value })
                }}
                defaultCountry={isOZAPI(organization) ? "AU" : "GB"}
                label={"Mobile number"}
                value={mobileNumber || ""}
                error={errors.missingMobile || errors.invalidMobileNumber}
                errorMessage={`Please enter a valid mobile number`}
                forceErrorDisplay={
                  mobileNumber &&
                  (errors.missingMobile || errors.invalidMobileNumber)
                }
              />
            </FormRow>
          )}
          {showHaventStartedUniversity && (
            <FormRow>
              <CheckboxField
                id={`haventStartedUniversity`}
                checked={haventStartedUniversity}
                onChange={(id, value) => {
                  this.setState({
                    haventStartedUniversity: !haventStartedUniversity,
                  })
                }}
                label={"I have not started university"}
                value={haventStartedUniversity || ""}
              />
            </FormRow>
          )}

          {showUniversity && (
            <React.Fragment>
              <FormRow>
                <UniversityName
                  isUndergraduate={true}
                  university={university}
                  hasErrors={hasErrors}
                  index={0}
                  type={UNDERGRADUATE}
                  showConfiguration={showConfigurationForUniversity}
                  errors={errors}
                  organization={organization}
                  handleOptionChange={this.handleOptionChange}
                  clearStateFields={this.clearStateFields}
                  handleChange={this.handleChange}
                  {...this.props}
                />
              </FormRow>
            </React.Fragment>
          )}
          {(showGraduationYear || showDegreeType) && (
            <UniversityRow>
              {showGraduationYear && (
                <UniversityRowItem>
                  <SelectField
                    size={"medium"}
                    id={`universityGraduationYear`}
                    label={"Graduation year"}
                    options={UNI_YEARS_LIST}
                    getOptionLabel={({ value }) => value}
                    value={universityGraduationYear}
                    error={errors.missingUniversityGraduationYear}
                    errorMessage={"Please select"}
                    forceErrorDisplay={hasErrors}
                    onChange={this.onChange}
                  />
                </UniversityRowItem>
              )}
              {showDegreeType && (
                <UniversityRowItem>
                  <SelectField
                    size={"medium"}
                    id={`degreeTypeId`}
                    label={"Degree type"}
                    options={DEGREE_TYPE}
                    getOptionLabel={({ label }) => label}
                    value={degreeTypeId}
                    error={errors.missingDegreeTypeId}
                    errorMessage={"Please select"}
                    forceErrorDisplay={hasErrors}
                    handleOptionChange={this.handleUniExtraOptionChange}
                    onChange={this.onChange}
                  />
                </UniversityRowItem>
              )}
            </UniversityRow>
          )}

          {showDietary && (
            <FormRow>
              <SwitchField
                id={"dietaryRequirements"}
                onChange={(id, value) => {
                  this.setState({ dietaryRequirements: value })
                }}
                value={dietaryRequirements}
                label={`Do you have any special dietary requirements or allergies?`}
                forceErrorDisplay={hasErrors}
                errorMessage={"Required"}
                error={errors.missingDietary}
                inlineLabels
              />
              {isBooleanTrue(dietaryRequirements) && (
                <EventPleaseSpecifyInput>
                  <InputField
                    label="Please specify"
                    maxLength={150}
                    xlarge
                    id={"dietaryRequirementsDetail"}
                    value={dietaryRequirementsDetail || ""}
                    onChange={ev => {
                      this.setState({
                        dietaryRequirementsDetail: ev.target.value,
                      })
                    }}
                    forceErrorDisplay={hasErrors}
                    errorMessage={"Required"}
                    error={errors.missingDietaryData}
                  />
                </EventPleaseSpecifyInput>
              )}
            </FormRow>
          )}
          {showAccessibility && (
            <FormRow>
              <SwitchField
                id={"accessibilityRequirements"}
                onChange={(id, value) => {
                  this.setState({ accessibilityRequirements: value })
                }}
                value={accessibilityRequirements}
                label={`Do you have any accessibility requirements to attend this event?`}
                forceErrorDisplay={hasErrors}
                errorMessage={"Required"}
                error={errors.missingAccessibility}
                inlineLabels
              />
              {isBooleanTrue(accessibilityRequirements) && (
                <EventPleaseSpecifyInput>
                  <InputField
                    label="Please specify"
                    hint={`Please let us know what additional support you require.
                    ${
                      replyToEmail
                        ? `Alternatively, if you would like to speak to someone in confidence prior to registering, please contact us on ${replyToEmail}.`
                        : ""
                    }`}
                    maxLength={150}
                    xlarge
                    id={"accessibilityRequirementsDetail"}
                    value={accessibilityRequirementsDetail || ""}
                    onChange={ev => {
                      this.setState({
                        accessibilityRequirementsDetail: ev.target.value,
                      })
                    }}
                    forceErrorDisplay={hasErrors}
                    errorMessage={"Required"}
                    error={errors.missingAccessibilityData}
                  />
                </EventPleaseSpecifyInput>
              )}
            </FormRow>
          )}
          {showHowDidYouHear && (
            <FormRow>
              <SelectField
                size={"mediumLarge"}
                id={`howDidYouHear`}
                label={"How did you hear about this event?"}
                options={org_heard}
                onChange={(id, value) =>
                  this.setState({ howDidYouHear: value.id })
                }
                getOptionLabel={({ value }) => value}
                value={org_heard.find(x => x.value === howDidYouHear)}
                error={missingHowDidYouHear}
                errorMessage={"Required"}
                forceErrorDisplay={hasErrors}
              />
            </FormRow>
          )}
          {showPhotoConsent && (
            <FormRow>
              <CheckboxField
                id={`photoConsent`}
                checked={photoConsent}
                onChange={(id, value) => {
                  this.setState({
                    photoConsent: !photoConsent,
                  })
                }}
                labelComponent={`I consent to ${organization.name} using any photographs taken of me during the event for promotional purposes.`}
                value={photoConsent || ""}
              />
            </FormRow>
          )}
          <FormRow>
            <CheckboxField
              id={`readTermsandConditions`}
              checked={readTermsandConditions}
              onChange={(id, value) => {
                this.setState({
                  readTermsandConditions: !readTermsandConditions,
                })
              }}
              labelComponent={termsComponent}
              value={readTermsandConditions || ""}
            />
          </FormRow>
          <FooterWrapper>
            <Button
              label={"Register"}
              disabled={
                !email ||
                !firstName ||
                !lastName ||
                SectionHasErrors(errors) ||
                !isEmail(email) ||
                !readTermsandConditions
              }
              onClick={() => {
                onConfirm({
                  firstName,
                  lastName,
                  email,
                  university,
                  degreeTypeId: degreeTypeId && degreeTypeId.value,
                  universityGraduationYear:
                    universityGraduationYear && universityGraduationYear.value,
                  mobileNumber,
                  dietaryRequirementsDetail,
                  dietaryRequirements,
                  accessibilityRequirements,
                  accessibilityRequirementsDetail,
                  photoConsent:
                    showPhotoConsent && isNull(photoConsent)
                      ? false
                      : photoConsent,
                  pronoun,
                  customPronoun,
                  howDidYouHear,
                })
              }}
              loading={loading}
            />
            <TextButton label={"Cancel"} onClick={onClose} />
          </FooterWrapper>
        </ContentWrapper>
      </Modal>
    )
  }
}

RegisterModal.propTypes = {
  onClose: PropTypes.func,
  isModalOpen: PropTypes.bool,
}
export default RegisterModal
